import {
  UserOutlined,
  ClusterOutlined,
  CarOutlined,
  FileTextOutlined,
  HourglassOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
  FileOutlined,
  HomeOutlined,
  ToolOutlined,
  SettingOutlined,
  AuditOutlined,
  AlertOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons';

export const getMenuIcon = (icon) => {
  switch (icon) {
    case 'UserOutlined':
      return <UserOutlined />;
    case 'ClusterOutlined':
      return <ClusterOutlined />;
    case 'CarOutlined':
      return <CarOutlined />;
    case 'FileTextOutlined':
      return <FileTextOutlined />;
    case 'HourglassOutlined':
      return <HourglassOutlined />;
    case 'UsergroupAddOutlined':
      return <UsergroupAddOutlined />;
    case 'DollarOutlined':
      return <DollarOutlined />;
    case 'FileOutlined':
      return <FileOutlined />;
    case 'HomeOutlined':
      return <HomeOutlined />;
    case 'ToolOutlined':
      return <ToolOutlined />;
    case 'SettingOutlined':
      return <SettingOutlined />;
    case 'AuditOutlined':
      return <AuditOutlined />;
    case 'AlertOutlined':
      return <AlertOutlined />;
    case 'CheckSquareOutlined':
      return <CheckSquareOutlined />;
    default:
      return null;
  }
};
